import React from 'react'
import ProtectedRoute from '../../internal/ProtectedRoute'
import BonusChecks from './BonusChecks'
import { Authorities } from '../../models/authorities'

const BonusChecksRoutes = () => {
  return [
    <ProtectedRoute
      key="/bonuschecks"
      path="/bonuschecks"
      exact
      authority={Authorities.PAY_APPLY}
      page={<BonusChecks />}
    />,
  ]
}

export default BonusChecksRoutes
